<div class="list-page tiimit-page">
  @if (kirjanpitajaOnDevaajaObservable | async) {
    <div class="debug-urit">
      <h3 style="margin: 0">Urit</h3>
      <div style="padding-top: 0.5em; padding-left: 1em; padding-right: 1em">
        Tiimit: <a [href]="tiimitEncodedUriObservable | async" target="_BLANK">{{ tiimitUriObservable | async }}</a>
      </div>
    </div>
  }

  @if (kokonaisuus()) {
    <div class="kokonaisuus-headeri mat-elevation-z1">
      <div class="kokonaisuus-otsikko">
        <span class="kokonaisuus-tagi">Tiimikokonaisuus</span>
        <span class="kokonaisuus-nimi">{{ kokonaisuus().nimi }}</span>
      </div>
      <div class="kokonaisuus-esihenkilot">
        <div class="osio-otsikko">
          <span>Esihenkilöt ({{ kokonaisuudenEsihenkilot().length }})</span>
          <app-secondary-button (click)="lisaaKokonaisuuteen()" actionId="Lisää kokonaisuuden esihenkilö" matIcon="add">Lisää</app-secondary-button>
        </div>
        @if (kokonaisuudenEsihenkilot().length === 0) {
          <div class="tyhja">Ei esihenkilöitä.</div>
        }
        @for (jasen of kokonaisuudenEsihenkilot(); track jasen.kirjanpitajaAvain + '-' + jasen.alku) {
          <div class="jasen-rivi" [class.paattynyt]="!jasen.aktiivinen">
            <span class="jasen-nimi">
              @if (jasen.primary) {
                <span class="primary-merkki" matTooltip="Ensisijainen tiimi tälle henkilölle">★</span>
              }
              {{ jasen.nimi }}
            </span>
            <span class="jasen-jakso">
              {{ jasen.alkuNaytettava | lnumberpvm | async }} -
              @if (jasen.loppu) {
                {{ jasen.loppu | lnumberpvm | async }}
              } @else {
                <em>jatkuu</em>
              }
            </span>
            <app-icon-button (click)="muokkaaKokonaisuudenJasenyytta(jasen)" actionId="Muokkaa kokonaisuuden esihenkilön jaksoa" matIcon="edit" matTooltip="Muokkaa jäsenyysjaksoa"></app-icon-button>
          </div>
        }
      </div>
    </div>
  }

  <div class="tiimit-grid">
    <div class="tiimit-lista mat-elevation-z1">
      <div class="lista-otsikko-rivi">
        <span class="lista-otsikko">Tiimit</span>
        <app-icon-button (click)="lisaaUusiTiimi()" actionId="Lisää uusi tiimi" matIcon="add" matTooltip="Lisää uusi tiimi"></app-icon-button>
      </div>
      @if (lataa()) {
        <div lemon-loading [show]="true"></div>
      } @else {
        @for (tiimi of tiimit(); track tiimi.avain) {
          <div class="tiimi-rivi" [class.valittu]="tiimi.avain === valittuAvain" (click)="valitseTiimi(tiimi)">
            <span class="tiimi-nimi">{{ tiimi.nimi }}</span>
            <span class="tiimi-jasenmaara">{{ tiimi.jasenmaaraAktiivisia }}</span>
          </div>
        }
      }
    </div>

    <div class="tiimi-detail mat-elevation-z1">
      @if (valittunTiimiNakymaObservable | async; as nakyma) {
        <div class="detail-otsikko">
          <span class="tiimi-detail-nimi">{{ nakyma.tiimi.nimi }}</span>
          <app-icon-button (click)="muokkaaTiimia(nakyma.tiimi)" actionId="Muokkaa tiimiä" matIcon="edit" matTooltip="Muokkaa tiimin nimeä ja voimassaoloa"></app-icon-button>
          <span class="tiimi-detail-meta">
            {{ naytettavaAlku(nakyma.tiimi.alku) | lnumberpvm | async }} -
            @if (nakyma.tiimi.loppu) {
              {{ nakyma.tiimi.loppu | lnumberpvm | async }}
            } @else {
              <em>jatkuu</em>
            }
          </span>
        </div>

        <div class="osio">
          <div class="osio-otsikko">
            <span>Esihenkilöt ({{ nakyma.esihenkilot.length }})</span>
            <app-secondary-button (click)="lisaaTiimiin(nakyma.tiimi, 'esihenkilo')" actionId="Lisää esihenkilö" matIcon="add">Lisää</app-secondary-button>
          </div>
          @if (nakyma.esihenkilot.length === 0) {
            <div class="tyhja">Ei esihenkilöitä.</div>
          }
          @for (jasen of nakyma.esihenkilot; track jasen.kirjanpitajaAvain + '-' + jasen.alku) {
            <div class="jasen-rivi" [class.paattynyt]="!jasen.aktiivinen">
              <span class="jasen-nimi">
                @if (jasen.primary) {
                  <span class="primary-merkki" matTooltip="Ensisijainen tiimi tälle henkilölle">★</span>
                }
                {{ jasen.nimi }}
              </span>
              <span class="jasen-jakso">
                @if (jasen.alkuNaytettava) {
                  {{ jasen.alkuNaytettava | lnumberpvm | async }}
                } @else {
                  ei tiedossa
                }
                -
                @if (jasen.loppu) {
                  {{ jasen.loppu | lnumberpvm | async }}
                } @else {
                  <em>jatkuu</em>
                }
              </span>
              <app-icon-button (click)="muokkaaTiiminJasenyytta(nakyma.tiimi, 'esihenkilo', jasen)" actionId="Muokkaa esihenkilön jaksoa" matIcon="edit" matTooltip="Muokkaa jäsenyysjaksoa"></app-icon-button>
            </div>
          }
        </div>

        <div class="osio">
          <div class="osio-otsikko">
            <span>Jäsenet ({{ nakyma.jasenet.length }})</span>
            <app-secondary-button (click)="lisaaTiimiin(nakyma.tiimi, 'jasen')" actionId="Lisää jäsen" matIcon="add">Lisää</app-secondary-button>
          </div>
          @if (nakyma.jasenet.length === 0) {
            <div class="tyhja">Ei jäseniä.</div>
          }
          @for (jasen of nakyma.jasenet; track jasen.kirjanpitajaAvain + '-' + jasen.alku) {
            <div class="jasen-rivi" [class.paattynyt]="!jasen.aktiivinen">
              <span class="jasen-nimi">
                @if (jasen.primary) {
                  <span class="primary-merkki" matTooltip="Ensisijainen tiimi tälle henkilölle">★</span>
                }
                {{ jasen.nimi }}
              </span>
              <span class="jasen-jakso">
                @if (jasen.alkuNaytettava) {
                  {{ jasen.alkuNaytettava | lnumberpvm | async }}
                } @else {
                  ei tiedossa
                }
                -
                @if (jasen.loppu) {
                  {{ jasen.loppu | lnumberpvm | async }}
                } @else {
                  <em>jatkuu</em>
                }
              </span>
              <app-icon-button (click)="muokkaaTiiminJasenyytta(nakyma.tiimi, 'jasen', jasen)" actionId="Muokkaa jäsenen jaksoa" matIcon="edit" matTooltip="Muokkaa jäsenyysjaksoa"></app-icon-button>
            </div>
          }
        </div>
      } @else if (!lataa()) {
        <div class="tyhja-detail">Valitse tiimi vasemmalta.</div>
      }
    </div>
  </div>
</div>
